var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pie-chart-area"},[(_vm.draw)?_c('div',{staticClass:"pie-chart-item"},[_c('canvas',{staticClass:"chart",attrs:{"id":("" + _vm.id),"height":_vm.calHeight}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }